import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M21.07 14.86a1 1 0 0 0-1.21-.93 7.5 7.5 0 0 1-9.79-9.79 1 1 0 0 0-1.31-1.18 9.5 9.5 0 1 0 12.28 12.28 1 1 0 0 0 .03-.38" }));
const ForwardRef = forwardRef(SvgMoon);
export default ForwardRef;
